import React from 'react';
import './PetAnimations.css';

export default function ShadowlingSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#0C1024';
  const bodyShade = '#1C2240';
  const glow = '#E040FB';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Magenta aura */}
      <circle cx="60" cy="56" r="44" fill={glow} opacity="0.08" />
      <circle cx="60" cy="56" r="34" fill={glow} opacity="0.1" />
      {/* Wispy shadow tail */}
      <path
        d="M86 78C96 70 104 56 100 48C97 42 93 46 92 52C90 60 88 70 84 76"
        fill={bodyShade}
        opacity="0.85"
      />
      {/* Body silhouette */}
      <ellipse cx="60" cy="76" rx="28" ry="20" fill={bodyColor} />
      {/* Belly shadow lift */}
      <ellipse cx="60" cy="82" rx="16" ry="10" fill={bodyShade} opacity="0.6" />
      {/* Legs (wispy stubs) */}
      <path d="M42 92C40 100 42 102 46 100" fill={bodyColor} />
      <path d="M78 92C80 100 78 102 74 100" fill={bodyColor} />
      <path d="M52 94C50 102 52 104 56 102" fill={bodyColor} />
      <path d="M68 94C70 102 68 104 64 102" fill={bodyColor} />
      {/* Head */}
      <ellipse cx="60" cy="48" rx="22" ry="20" fill={bodyColor} />
      {/* Pointed ears */}
      <path d="M42 32L34 12L50 28Z" fill={bodyColor} />
      <path d="M78 32L86 12L70 28Z" fill={bodyColor} />
      {/* Inner ear hint */}
      <path d="M44 28L40 18L48 28Z" fill={bodyShade} />
      <path d="M76 28L80 18L72 28Z" fill={bodyShade} />
      {/* Snout shadow */}
      <ellipse cx="60" cy="56" rx="10" ry="6" fill={bodyShade} opacity="0.7" />
      {/* Glowing eyes (magenta) */}
      <ellipse cx="52" cy="46" rx="4" ry="3" fill={glow} />
      <ellipse cx="68" cy="46" rx="4" ry="3" fill={glow} />
      <circle cx="60" cy="46" r="6" fill={glow} opacity="0.15" />
      <ellipse cx="52" cy="46" rx="2" ry="1.5" fill="white" opacity="0.9" />
      <ellipse cx="68" cy="46" rx="2" ry="1.5" fill="white" opacity="0.9" />
      {/* Faint mouth */}
      <path d="M55 58C58 60 62 60 65 58" stroke={glow} strokeWidth="0.8" strokeLinecap="round" fill="none" opacity="0.7" />
      {/* Floating shadow wisps */}
      <circle cx="28" cy="84" r="2" fill={bodyShade} opacity="0.4" />
      <circle cx="94" cy="86" r="1.5" fill={bodyShade} opacity="0.4" />
      <circle cx="36" cy="98" r="1.2" fill={glow} opacity="0.3" />
      <circle cx="86" cy="98" r="1" fill={glow} opacity="0.3" />
    </svg>
  );
}
